// utils/pdfService.util.js (JS plano)
// Descarga un PDF desde el gateway con API.get(...), lo valida y devuelve base64 + data URI.
import { API } from "../queries/api";

 
const buildPath = (tipo, id) => {
  switch (tipo) {
    case 'budget':   return `/policy/budget/budget-document/${id}`;
    case 'proposal': return `/policy/proposal/proposal-document/${id}`;
    case 'policy':   return `/policy/policy/policy-document/${id}`;
    default: throw new Error('tipoDocumento inválido');
  }
};

const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  const chunk = 0x8000;
  let binary = '';
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + chunk)));
  }
  if (typeof btoa === 'function') return btoa(binary);
  if (typeof global !== 'undefined' && global.Buffer) return global.Buffer.from(bytes).toString('base64');
  return '';
};

const isPdfByMagic = (buf) => {
  const b = new Uint8Array(buf);
  // Firma "%PDF-"
  return b.length >= 5 && b[0] === 0x25 && b[1] === 0x50 && b[2] === 0x44 && b[3] === 0x46 && b[4] === 0x2d;
};

const parseFilename = (cd) => {
  if (!cd) return null;
  const m = cd.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
  return decodeURIComponent((m && (m[1] || m[2])) || '');
};

export async function fetchPdf(tipoDocumento, id) {
  try {
    const url = buildPath(tipoDocumento, id);
    const res = await API.get(url, { responseType: 'arraybuffer' });

    const buf = res.data; // ArrayBuffer
    const headers = (res && res.headers) || {};
    const ct = headers['content-type'];
    const cd = headers['content-disposition'];

    const isPdf = (ct && /application\/(pdf|octet-stream)/i.test(ct)) || isPdfByMagic(buf);

    const base64 = arrayBufferToBase64(buf);
    const dataUri = `data:application/pdf;base64,${base64}`;
    const filename = parseFilename(cd);

    return { ok: true, isPdf, base64, dataUri, filename, contentType: ct || null };
  } catch (e) {
    return {
      ok: false,
      isPdf: false,
      status: e && e.response && e.response.status,
      error: (e && e.message) || 'fetch error',
    };
  }
}

/**
 * Genera un HTML autocontenido con PDF.js para renderizar un PDF en un <WebView> móvil.
 * - No depende de código nativo adicional.
 * - Cargamos PDF.js por CDN y dibujamos todas las páginas en <canvas>.
 * - b64 debe ser SOLO el contenido base64 (sin prefijo data:...)
 */
export function buildPdfHtml(b64) {
  const safeB64 = String(b64);
  return `<!doctype html>
    <html>
    <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <style>
        html, body { margin: 0; padding: 0; height: 100%; }
        #viewer { min-height: 100%; }
        canvas { display: block; width: 100%; margin: 0 0 8px; }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.min.js"></script>
        <script>
        document.addEventListener('DOMContentLoaded', async function () {
            try {
            // Worker de PDF.js
            pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.js';
            // Decodifica el base64 a bytes
            const raw = atob('${safeB64}');
            const data = new Uint8Array(raw.length);
            for (let i = 0; i < raw.length; i++) data[i] = raw.charCodeAt(i);
            // Carga del documento y renderizado página a página
            const pdf = await pdfjsLib.getDocument({ data }).promise;
            const viewer = document.getElementById('viewer');
            for (let p = 1; p <= pdf.numPages; p++) {
                const page = await pdf.getPage(p);
                const viewport = page.getViewport({ scale: 1.2 });
                const canvas = document.createElement('canvas');
                canvas.width = viewport.width; canvas.height = viewport.height;
                const ctx = canvas.getContext('2d');
                await page.render({ canvasContext: ctx, viewport }).promise;
                viewer.appendChild(canvas);
            }
            // Comunica al WebView que terminó
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage('ready');
            }
            } catch (e) {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage('error');
            }
            }
        });
        </script>
    </head>
    <body>
        <div id="viewer"></div>
    </body>
    </html>`;
}